<template>
    <md-dialog ref="reauthenticate" @open="opened" @close="closed" class="reauthenticate-modal">
        <md-dialog-title>
            <div class="modal-title">Reauthenticate</div>
        </md-dialog-title>
        <md-dialog-content class="reauthenticate-modal-content">
            <md-layout md-flex="100" md-align="center" v-if="user.signInMethod === 'email'">
                <md-input-container md-has-password>
                    <label for="password">Password</label>
                    <md-input type="password" v-model="password"></md-input>
                </md-input-container>
                <md-button class="md-raised md-primary" @click="reAuthByEmail"><md-icon>mail</md-icon>&nbsp;Reauthenticate</md-button>
            </md-layout>
            <md-layout md-flex="100" md-align="center" v-else>
                <md-button class="md-raised md-primary" @click="reAuthByGoogle"><md-icon>person</md-icon>&nbsp;Reauthenticate</md-button>
            </md-layout>
        </md-dialog-content>
    </md-dialog>
</template>

<script>
import firebase from 'firebase/app';
import { mapGetters } from 'vuex';

const Reauthenticate = {
    name: 'reauthenticate',
    data: function() {
        return {
            password: '',
            status: false
        };
    },
    computed: {
        ...mapGetters([
            'user',
            'users',
            'showMode'
        ])
    },
    methods: {
        open() {
            this.$refs.reauthenticate.open();
        },
        closeDialog() {
            this.$refs.reauthenticate.close();
        },
        opened() {
            this.password = '';
            this.status = false;
            this.$emit('open');
        },
        closed() {
            this.$emit('close', this.status);
        },
        cancel() {
            this.$refs.reauthenticate.close();
        },
        async reAuthByEmail() {
            const currentUser = firebase.auth().currentUser;
            const credential = firebase.auth.EmailAuthProvider.credential(this.user.email, this.password);
            try {
                await currentUser.reauthenticateWithCredential(credential);
                this.status = true;
                this.closeDialog();
            } catch (error) {
                this.password = '';
                this.$notify({
                    group: 'auth',
                    type: 'error',
                    title: 'Failed to reauthenticate',
                    text: error.message
                });
            }
        },
        async reAuthByGoogle() {
            const currentUser = firebase.auth().currentUser;
            try {
                await currentUser.reauthenticateWithPopup(new firebase.auth.GoogleAuthProvider());
                this.status = true;
                this.closeDialog();
            } catch (error) {
                this.$notify({
                    group: 'auth',
                    type: 'error',
                    title: 'Failed to reauthenticate',
                    text: error.message
                });
            }
        }
    }
};
export default Reauthenticate;
</script>

<style lang="scss">
.reauthenticate-modal {
    .md-dialog {
        width: 480px;
    }
    .md-dialog-title {
        background: #081e4f;
        line-height: 1.4;
        text-align: center;
        color: white;
        padding: 1rem;
    }
    .md-error {
        color: #e5424d;
        font-size: 12px;
    }
}
</style>


// WEBPACK FOOTER //
// reauthenticate.vue?4bb85a98